var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 543,
    height: 302,
    viewBox: "0 0 543 302",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.337 15.1364C174.505 1.63354 240.097 -6.29851 288.908 9.21028C338.499 24.9591 371.31 64.1489 413.472 98.2463C456.413 132.584 507.926 161.589 530.104 197.033C552.281 232.478 544.344 274.121 500.751 291.177C456.884 308.617 377.086 301.853 310.81 290.813C243.48 279.917 190.176 265.369 149.937 244.528C109.422 224.071 82.7511 197.561 53.3306 166.921C23.9102 136.28 -7.20535 101.365 1.5543 74.5148C10.589 47.2803 59.2239 28.495 116.337 15.1364Z",
    fill: "#FF9900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.bc45a146e1e479f7e9ec610c489a4d1c.svg";
export { ForwardRef as ReactComponent };